import { ReactNode } from 'react';
import onboardingImage from '../../assets/onboardingImage.png';

interface DesktopViewProps {
  children: ReactNode;
  t: (key: string) => string;
}

const DesktopView = ({ children, t }: DesktopViewProps) => {
  return (
    <div className="lg:flex h-screen w-full">
      <div className="onboarding-container">
        <div className="flex flex-col items-center w-full min-h-screen">
          <div className="w-full max-w-md xl:max-w-xl mx-auto mt-[50px] px-[50px]">
            {children}
          </div>
        </div>
      </div>

      <div className="hidden md:flex w-3/5 items-center justify-center m-6">
        <img
          src={onboardingImage}
          alt={t('onboarding.onboardingLayoutAlt')}
          className="w-full h-full object-cover rounded-2xl"
        />
      </div>
    </div>
  );
};

export default DesktopView;
